var _defs, _g, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 380",
    width: 380,
    height: 380,
    role: "img",
    "aria-label": "IMMO INTEREST",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tshadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 22,
    stdDev: 34,
    floodColor: "#142878",
    floodOpacity: 0.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tshadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 300,
    height: 300,
    rx: 80,
    fill: "#2F5BFF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 217.9,
    y: 124.9,
    width: 14.88,
    height: 48.36,
    rx: 2.98,
    fill: "#FF6A2B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.00,97.00) scale(1.8600)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 54 L50 24 L84 54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 50 V80 H72 V50"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.6621bd37bad0e5c2c84f876b124a8d4e.svg";
export { ForwardRef as ReactComponent };